export default {
  // Transaction direction
  transactionDirection: "Transaction Direction:",
  inflow: "Inflow",
  outflow: "Outflow",
  bidirectional: "Bidirectional",

  // Transaction direction tooltips
  inflowTooltip: "Expand nodes in the inflow direction",
  outflowTooltip: "Expand nodes in the outflow direction",
  bidirectionalTooltip: "Expand nodes in both inflow and outflow directions",

  // Node operations
  nodeOperation: "Node Operation:",
  directAssociation: "Direct Association",
  batchExpansion: "Batch Expansion",
  batchBalanceQuery: "Batch Balance Query",
  commonCounterparty: "Common Counterparty",
  exchangeExpansion: "Exchange Expansion",

  // Node operation tooltips
  directAssociationTooltip: "Transaction relationships between selected nodes",
  batchExpansionTooltip: "Batch expand selected nodes",
  batchBalanceQueryTooltip: "Batch query balances of selected nodes",
  commonCounterpartyTooltip:
    "Common Counterparty: Analyze common inflow or outflow counterparties of multiple addresses",
  exchangeExpansionTooltip:
    "Exchange Expansion: Expand aggregation points of a single address flowing in or out to exchanges",

  // AI Model
  aiModel: "AI Model:",
  firstFeeTraceability: "First Fee Traceability",
  multilayerTraceability: "Multilayer Traceability",
  transactionPathAnalysis: "Transaction Path Analysis",
  newOldStopModel: "New-Old Stop Model",
  singleChannelModel: "Single Channel Transfer Model",

  // AI Model tooltips
  firstFeeTraceabilityTooltip:
    "First Fee Traceability: Trace exchange addresses within 5 levels of a single address",
  multilayerTraceabilityTooltip:
    "Multilayer Traceability: Trace transaction paths of inflow or outflow within up to 3 levels of a single address",
  transactionPathAnalysisTooltip:
    "Transaction Path Analysis: Analyze waypoints and transaction paths from multiple starting addresses to destination addresses within 2 levels",
  newOldStopModelTooltip:
    "New-Old Stop Model: The New-Old Stop Model is used to analyze the migration behavior of illicit addresses. Users can specify target addresses and filtering conditions, and the system will automatically retrieve the earliest or latest transaction of that address to identify whether the address is activated or deactivated. The model can discover complete fund transfers when illicit actors change their receiving addresses, helping to track their latest active addresses or trace back to historical addresses, providing key clues for on-chain tracking and risk analysis.",
  singleChannelModelTooltip:
    "Single Channel Transfer Model: This model is used to identify transfer behavior in the process of illicit fund movement. The system starts from a specified address and analyzes its fund inflow and outflow relationships layer by layer, searching for address chains with highly concentrated fund flows. The model continuously tracks along these highly dependent transfer paths until the funds show dispersed flow, thereby revealing the main transfer paths of illicit funds.",

  // Success message
  directionModifiedSuccess: "Transfer direction modified successfully!",
};
